module.exports = __webpack_public_path__ + "img/profile.ead4be2d.svg";